import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { TID } from "@/constants/testIds";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/", { replace: true }); return; }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        // Store bearer token as fallback (extension-friendly, works if cookies get blocked)
        if (data?.session_token) {
          localStorage.setItem("clyde_session_token", data.session_token);
        }
        setUser({
          user_id: data.user_id, email: data.email, name: data.name,
          picture: data.picture, created_at: new Date().toISOString(),
        });
        // Clean hash then navigate
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        console.error("Auth exchange failed", e);
        navigate("/", { replace: true });
      }
    })();
  }, []);// eslint-disable-line

  return (
    <div data-testid={TID.authCallbackRoot} className="min-h-screen flex items-center justify-center bg-[#09090B] text-white">
      <div className="text-center">
        <div className="overline mb-3">signing you in</div>
        <div className="font-display text-3xl">handshaking with clydeflow…</div>
      </div>
    </div>
  );
}
